// extracted by mini-css-extract-plugin
module.exports = {"section":"Tagline_section__MTjDH","statRow":"Tagline_statRow__13qMp","statValue":"Tagline_statValue__NlCc6"};